import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import {
  Box, Flex, Button, Image, Avatar, Text, useColorMode, Stack, Grid, GridItem, Stat, StatLabel, StatNumber, Icon,
  useDisclosure, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, IconButton,
  SimpleGrid, Select, ButtonGroup, Badge, useColorModeValue, Alert, AlertIcon, AlertTitle, AlertDescription, Progress, Input, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, FormControl, FormLabel, InputGroup, InputRightElement
} from "@chakra-ui/react";

import {
  LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine, Cell
} from 'recharts';

import { FaWalking, FaHeart, FaWeight, FaRulerVertical, FaHeartbeat, FaBars, FaFire, FaRoute, FaRunning, FaShoePrints, FaLock, FaDownload } from "react-icons/fa";
import { BiBarChart, BiLineChart } from 'react-icons/bi';

import Logo from "../fitness.png";
import Loading from "./Loader";
import GaugeChart from 'react-gauge-chart';
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import id from 'date-fns/locale/id';
registerLocale('id', id);

const HARDCODED_PASSWORD = 'Tcnsehat2024!';
const API_BASE = process.env.REACT_APP_API_BASE || window.location.origin + '/api';

const DashboardContent = () => {
  const [fitnessData, setFitnessData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [jumlahHari, setJumlahHari] = useState(7);
  const [chartType, setChartType] = useState('bar');
  const { colorMode, toggleColorMode } = useColorMode();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cardBg = useColorModeValue("white", "gray.600");
  const navigate = useNavigate();

  const [bmi, setBmi] = useState(0);
  const [bmiCategory, setBmiCategory] = useState('');
  const [bmiColor, setBmiColor] = useState('#718096');
  const [latestWeight, setLatestWeight] = useState(0);
  const [latestHeight, setLatestHeight] = useState(0);
  const [userEmail, setUserEmail] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedData, setSelectedData] = useState(null);
  const [historyData, setHistoryData] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);

  const [kirimLoading, setKirimLoading] = useState(false);
  const [kirimStatus, setKirimStatus] = useState('');

  const { isOpen: isPasswordOpen, onOpen: onPasswordOpen, onClose: onPasswordClose } = useDisclosure();
  const [inputPassword, setInputPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const [historySelectedDate, setHistorySelectedDate] = useState('');
  const dataChart = fitnessData?.data || [];
  const componentRef = useRef();

  const fetchData = useCallback(async (days) => {
    setIsLoading(true);
    const email = sessionStorage.getItem('userEmail');
    if (!email) {
      setIsLoading(false);
      return;
    }

    try {
      const res = await axios.post(`${API_BASE}/google-fit`, { email, days });
      setFitnessData(res.data);
      setBmi(res.data.bmi || 0);
      setBmiCategory(res.data.bmiCategory || '');
      setBmiColor(res.data.bmiColor || '#718096');
      setLatestWeight(res.data.latestWeight || 0);
      setLatestHeight(res.data.latestHeight || 0);
    } catch (err) {
  if (err.response?.status === 401) {
    alert('Akses Google dicabut. Silakan login ulang.');
    sessionStorage.removeItem('userEmail');
    setUserEmail('');
    setFitnessData(null);
    
    // Auto redirect ke auth URL
    fetch(`${API_BASE}/google-fit/auth-url`)
      .then(res => res.json())
      .then(data => {
        window.location.href = data.url; // buka layar consent Google
      });
  } else {
    alert('Gagal refresh data: ' + (err.response?.data?.error || err.message));
  }
} finally {
      setIsLoading(false);
    }
  }, []);

const handleLogout = () => {
    // Kalau ada token, hapus dulu biar bener-bener logout
    sessionStorage.removeItem('googleFitToken');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    setUserEmail('');
  setFitnessData(null);

  setSelectedData(null);
  setBmi(0);
  setBmiCategory('');
  setLatestWeight(0);
  setLatestHeight(0);
  
  setSelectedDate(formatDateString(new Date()));
  
  // 3. Logout Google OAuth biar bener-bener sign out
  if (window.google?.accounts?.id) {
    window.google.accounts.id.disableAutoSelect();
  }
    navigate("/"); // <-- balik ke FirstPage
 };

  const parseDateString = (tglString) => {
    if (!tglString) return null;
    const tahun = new Date().getFullYear();
    const bulanMap = { Jan:0, Feb:1, Mar:2, Apr:3, Mei:4, Jun:5, Jul:6, Agu:7, Sep:8, Okt:9, Nov:10, Des:11 };
    const parts = tglString.split(', ')[1]?.split(' ');
    if (!parts || parts.length < 2) return null;
    const day = parseInt(parts[0]);
    const month = bulanMap[parts[1]];
    return isNaN(day) || month === undefined? null : new Date(tahun, month, day);
  };

  const formatDateString = (date) => {
    if (!date) return '';
    const hari = ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'];
    const bulan = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'];
    return `${hari[date.getDay()]}, ${date.getDate()} ${bulan[date.getMonth()]}`;
  };

  const formatDateToMySQL = (date) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const tanggalAdaData = dataChart
   .map(d => parseDateString(d.tanggal))
   .filter(Boolean)
   .map(d => d.toDateString());

  const today = new Date();
  const minDate = new Date();
  minDate.setDate(today.getDate() - 90);

  const filterTanggal = (date) => {
    return tanggalAdaData.includes(date.toDateString());
  };

  const handleGantiTanggalKalender = (date) => {
    const tglFormat = formatDateString(date);
    setSelectedDate(tglFormat);
    const found = dataChart.find(d => d.tanggal === tglFormat);
    setSelectedData(found || null);
  };

  useEffect(() => {
    const savedEmail = sessionStorage.getItem('userEmail');
    if (savedEmail) {
      setUserEmail(savedEmail);
      fetchData(jumlahHari);
    }
  }, [fetchData, jumlahHari]);

  useEffect(() => {
    const handleMessage = async (event) => {
      if (event.origin!== 'https://fitness.tcnsehat.top') return;

      if (event.data.type === 'GOOGLE_AUTH_CODE') {
        const code = event.data.code;
        setIsLoading(true);

        try {
          const res = await axios.post(`${API_BASE}/save-google-token`, { code });
          if (res.data.success) {
            setUserEmail(res.data.email);
            sessionStorage.setItem('userEmail', res.data.email);
            fetchData(jumlahHari);
       
          }
        } catch (err) {
          alert('Gagal simpan token: ' + (err.response?.data?.error || err.message));
        } finally {
          setIsLoading(false);
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [fetchData, jumlahHari]);

  const loginWithGoogle = () => {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const redirectUri = 'https://fitness.tcnsehat.top/api/oauth/callback';
    const scope = encodeURIComponent(
      'openid email https://www.googleapis.com/auth/fitness.activity.read https://www.googleapis.com/auth/fitness.body.read https://www.googleapis.com/auth/fitness.heart_rate.read https://www.googleapis.com/auth/fitness.sleep.read'
    );

    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&access_type=offline&prompt=consent`;
    window.open(authUrl, 'googleLogin', 'width=500,height=600');
  };

  const handleGantiHari = (e) => {
    const hari = parseInt(e.target.value);
    setJumlahHari(hari);
    if (sessionStorage.getItem('userEmail')) {
      fetchData(hari);
    }
  };

  useEffect(() => {
    if (dataChart.length > 0) {
      const last = dataChart[dataChart.length - 1];
      setSelectedDate(last.tanggal);
      setSelectedData(last);
    }
  }, [dataChart]);

const fetchHistoryFromDB = async (days) => {
  if (!userEmail) return;
  setHistoryLoading(true);
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_BASE}/health-history`, {
      params: { email: userEmail, days: days }
    });
    
    console.log('RESPONSE:', res.data); // buat cek

    // FIX: ambil res.data
    const cleanData = (res.data || []).map(d => ({
      tanggal: d.tanggal,           // "Sen, 30 Sep"
      tanggal_raw: d.tanggal_raw,   // "2026-05-01"
      bmi: parseFloat(d.bmi) || 0,
      health_score: parseInt(d.health_score) || 0,
      weight: parseFloat(d.weight) || 0,
      height: parseFloat(d.height) || 0,
      health_label: d.health_label,
      bmi_category: d.bmi_category,
      langkah: d.langkah || 0,
      heart_rate: d.heart_rate || 0,
      sleepMinutes: d.sleepMinutes || 0,
      menitAktif: d.menitAktif || 0,
      resting_heart_rate: d.resting_heart_rate || 0,
      oxygen_saturation: d.oxygen_saturation || 0
    }));
    
    console.log('HISTORY DATA:', cleanData);
    setHistoryData(cleanData);
  } catch (err) {
    console.error('Gagal ambil history:', err);
    setHistoryData([]); // biar chart nggak error
  } finally {
    setHistoryLoading(false);
  }
};


useEffect(() => {
  if (userEmail) {
    const today = formatDateToMySQL(new Date()); // "2026-05-28"
    setHistorySelectedDate(today);
    fetchHistoryFromDB(jumlahHari, today);
  }
}, [userEmail, jumlahHari]);

  const getLastWeightHeight = (targetDate) => {
    if (!dataChart.length ||!targetDate) return { weight: latestWeight, height: latestHeight, tanggal: null };
    const validData = dataChart
     .filter(d => d.tanggal <= targetDate && d.weight > 0 && d.height > 0)
     .sort((a, b) => new Date(b.tanggal) - new Date(a.tanggal));
    if (validData.length > 0) {
      return {
        weight: validData[0].weight,
        height: validData[0].height,
        tanggal: validData[0].tanggal
      };
    }
    return { weight: latestWeight, height: latestHeight, tanggal: null };
  };

  const lastWeightHeight = getLastWeightHeight(selectedDate);
  const displaySteps = selectedData?.step_count || 0;
  const displayHeartRate = selectedData?.heart_rate || 0;
  const displayCardio = selectedData?.menitAktif || 0;
  const displayWeight = selectedData?.weight || lastWeightHeight.weight || 0;
  const displayHeight = selectedData?.height || lastWeightHeight.height || 0;

  const calculateBmiByDate = () => {
    if (!displayWeight ||!displayHeight) return { bmi: 0, category: 'Tidak ada data', color: '#718096' };
    const bmiValue = displayWeight / ((displayHeight / 100) * (displayHeight / 100));
    let category = '';
    let color = '';
    if (bmiValue < 18.5) { category = 'Underweight'; color = '#3182CE'; }
    else if (bmiValue < 25) { category = 'Normal'; color = '#38A169'; }
    else if (bmiValue < 30) { category = 'Overweight'; color = '#ECC94B'; }
    else if (bmiValue < 35) { category = 'Obese I'; color = '#ED8936'; }
    else { category = 'Obese II'; color = '#E53E3E'; }
    return { bmi: bmiValue, category, color };
  };

  const displayBmiData = calculateBmiByDate();
  const displayBmi = displayBmiData.bmi;
  const displayBmiCategory = displayBmiData.category;
  const displayBmiColor = displayBmiData.color;

  const getHealthScoreByDate = () => {
    if (!selectedData) return { label: 'Belum Ada Data', color: 'gray', persen: 0 };
    let skor = 0;
    const bmiValue = displayWeight && displayHeight? displayWeight / ((displayHeight / 100) * (displayHeight / 100)) : 0;
    if (bmiValue >= 18.5 && bmiValue < 25) skor += 20;
    else if (bmiValue >= 25 && bmiValue < 30) skor += 10;
    if (selectedData.step_count >= 10000) skor += 20;
    else if (selectedData.step_count >= 7500) skor += 15;
    else if (selectedData.step_count >= 5000) skor += 10;
    if (selectedData.resting_heart_rate >= 60 && selectedData.resting_heart_rate <= 100) skor += 20;
    else if (selectedData.resting_heart_rate > 0) skor += 10;
    const jamTidur = (selectedData.sleepMinutes || 0) / 60;
    if (jamTidur >= 7 && jamTidur <= 9) skor += 20;
    else if (jamTidur >= 6) skor += 10;
    if (selectedData.menitAktif >= 22) skor += 20;
    else if (selectedData.menitAktif >= 11) skor += 10;
    const persen = Math.round((skor / 100) * 100);
    if (persen >= 80) return { label: 'Sangat Sehat', color: 'green', persen };
    if (persen >= 60) return { label: 'Sehat', color: 'teal', persen };
    if (persen >= 40) return { label: 'Cukup', color: 'orange', persen };
    return { label: 'Kurang Sehat', color: 'red', persen };
  };

  const displayHealthScore = getHealthScoreByDate();

  const getHealthDetail = () => {
    if (!selectedData) return [];
    return [
      {
        indikator: 'BMI',
        aktual: displayBmi >= 18.5 && displayBmi < 25? 100 : displayBmi >= 25 && displayBmi < 30? 50 : 0,
        target: 100,
        nilai: displayBmi? displayBmi.toFixed(1) : '-',
        satuan: ''
      },
      {
        indikator: 'Langkah',
        aktual: Math.min(100, Math.round((selectedData.step_count || 0) / 100)),
        target: 100,
        nilai: selectedData.step_count || 0,
        satuan: ' langkah'
      },
      {
        indikator: 'RHR',
        aktual: selectedData.resting_heart_rate >= 60 && selectedData.resting_heart_rate <= 100? 100 : selectedData.resting_heart_rate > 0? 50 : 0,
        target: 100,
        nilai: selectedData.resting_heart_rate || '-',
        satuan: ' bpm'
      },
      {
        indikator: 'Tidur',
        aktual: Math.min(100, Math.round(((selectedData.sleepMinutes || 0) / 60) / 8 * 100)),
        target: 100,
        nilai: selectedData.sleepMinutes? `${Math.floor(selectedData.sleepMinutes/60)}j ${selectedData.sleepMinutes%60}m` : '-',
        satuan: ''
      },
      {
        indikator: 'Kardio',
        aktual: Math.min(100, Math.round((selectedData.menitAktif || 0) / 22 * 100)),
        target: 100,
        nilai: selectedData.menitAktif || 0,
        satuan: ' poin'
      },
      {
        indikator: 'Oksigen',
        aktual: selectedData.oxygen_saturation >= 95? 100 : selectedData.oxygen_saturation >= 90? 70 : 0,
        target: 100,
        nilai: selectedData.oxygen_saturation || '-',
        satuan: '%'
      }
    ];
  };

  const healthDetail = getHealthDetail();

  const handleOpenPasswordModal = () => {
    if (!dataChart.length) {
      alert('Data kosong. Connect Google Fit dulu.');
      return;
    }
    setInputPassword('');
    setPasswordError('');
    onPasswordOpen();
  };

  const handleSubmitPassword = async () => {
    if (!inputPassword) {
      setPasswordError('Password wajib diisi');
      return;
    }
    if (inputPassword!== HARDCODED_PASSWORD) {
      setPasswordError('Password salah!');
      return;
    }
    onPasswordClose();
    await kirimData7Hari();
  };

  const kirimData7Hari = async () => {
    if (!selectedDate ||!selectedData) {
      return alert('Pilih tanggal dulu di kalender');
    }

    setKirimLoading(true);
    setKirimStatus('Mengirim data 7 hari...');

    const selectedIndex = dataChart.findIndex(d => d.tanggal === selectedDate);
    if (selectedIndex === -1) {
      setKirimLoading(false);
      return alert('Data tanggal yang dipilih tidak ada');
    }

    const startIndex = Math.max(0, selectedIndex - 6);
    const last7DaysFromSelected = dataChart.slice(startIndex, selectedIndex + 1);

    if (!last7DaysFromSelected.length) {
      setKirimLoading(false);
      return alert('Tidak ada data 7 hari ke belakang');
    }

    const calculateHealthScore = (data, weight, height) => {
      let skor = 0;
      const bmiValue = weight && height? weight / ((height / 100) * (height / 100)) : 0;
      if (bmiValue >= 18.5 && bmiValue < 25) skor += 20;
      else if (bmiValue >= 25 && bmiValue < 30) skor += 10;
      if (data.step_count >= 10000) skor += 20;
      else if (data.step_count >= 7500) skor += 15;
      else if (data.step_count >= 5000) skor += 10;
      if (data.resting_heart_rate >= 60 && data.resting_heart_rate <= 100) skor += 20;
      else if (data.resting_heart_rate > 0) skor += 10;
      const jamTidur = (data.sleepMinutes || 0) / 60;
      if (jamTidur >= 7 && jamTidur <= 9) skor += 20;
      else if (jamTidur >= 6) skor += 10;
      if (data.menitAktif >= 22) skor += 20;
      else if (data.menitAktif >= 11) skor += 10;
      const persen = Math.round((skor / 100) * 100);
      let label = 'Kurang Sehat';
      if (persen >= 80) label = 'Sangat Sehat';
      else if (persen >= 60) label = 'Sehat';
      else if (persen >= 40) label = 'Cukup';
      return { persen, label };
    };

    const records = last7DaysFromSelected.map(d => {
      const weight = d.weight || getLastWeightHeight(d.tanggal).weight || 0;
      const height = d.height || getLastWeightHeight(d.tanggal).height || 0;

      let bmi = 0, bmiCategory = '';
      if (weight > 0 && height > 0) {
        const heightM = height / 100;
        bmi = parseFloat((weight / (heightM * heightM)).toFixed(1));
        if (bmi < 18.5) bmiCategory = 'Underweight';
        else if (bmi < 25) bmiCategory = 'Normal';
        else if (bmi < 30) bmiCategory = 'Overweight';
        else if (bmi < 35) bmiCategory = 'Obese I';
        else bmiCategory = 'Obese II';
      }

      const { persen, label } = calculateHealthScore(d, weight, height);

      return {
        userEmail: userEmail,
        tanggal: formatDateToMySQL(parseDateString(d.tanggal)),
        energi: d.energi || 0,
        jarakKm: d.jarakKm || 0,
        menitBergerak: d.menitBergerak || 0,
        menitAktif: d.menitAktif || 0,
        step_count: d.step_count || 0,
        kaloriMasuk: d.calories_in || 0,
        kaloriKeluar: d.energi || 0,
        sleepMinutes: d.sleepMinutes || 0,
        weight: weight,
        height: height,
        heart_rate: d.heart_rate || 0,
        water: d.water || 0,
        resting_heart_rate: d.resting_heart_rate || 0,
        oxygen_saturation: d.oxygen_saturation || 0,
        blood_glucose: d.blood_glucose || 0,
        bmi: bmi,
        bmiCategory: bmiCategory,
        healthScore: persen,
        healthLabel: label,
        raw_data: d
      };
    });

    try {
      const res = await axios.post(`${API_BASE}/save-health-records-batch`, { records }, { timeout: 30000 });
      if (res.data.success) {
        setKirimStatus(`Sukses: ${records.length} hari terkirim`);
        alert(`Berhasil kirim data dari ${records[0].tanggal} sampai ${records[records.length-1].tanggal}\n${res.data.message}`);
      }
    } catch (err) {
      const msg = err.response?.data?.error || err.message;
      setKirimStatus(`Gagal: ${msg}`);
      alert(`Gagal kirim: ${msg}`);
    } finally {
      setKirimLoading(false);
      setInputPassword('');
    }
  };

  const ChartCard = ({ title, dataKey, name, unit = '', icon }) => (
    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container">
      <Flex justify="space-between" align="center" mb={3}>
        <Box>
          <Text fontWeight="bold">{title}</Text>
          <Text fontSize="xs" color="gray.500">{jumlahHari} hari terakhir</Text>
        </Box>
        <Icon as={icon} boxSize={6} color="blue.500" />
      </Flex>
      <ResponsiveContainer width="100%" height={250}>
        {chartType === 'bar'? (
          <BarChart data={dataChart}>
            <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
            <XAxis dataKey="tanggal" fontSize={11} />
            <YAxis />
            <Tooltip formatter={(v) => `${v} ${unit}`} />
            <Bar dataKey={dataKey} fill="#3182CE" name={name} radius={[4, 4, 0, 0]} />
          </BarChart>
        ) : (
          <LineChart data={dataChart}>
            <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
            <XAxis dataKey="tanggal" fontSize={11} />
            <YAxis />
            <Tooltip formatter={(v) => `${v} ${unit}`} />
            <Line type="monotone" dataKey={dataKey} stroke="#3182CE" strokeWidth={3} dot={{ r: 3 }} name={name} />
          </LineChart>
        )}
      </ResponsiveContainer>
    </GridItem>
  );


  // TAROK SEBELUM return ( DI DALAM DashboardContent YG PERTAMA





  return (
    <>
      {isLoading? (
        <Loading />
      ) : (
        <Box>
<Box bg={colorMode === "light"? "black" : "pink.800"} px={{ base: 2, md: 4 }} py={2} color="white" position="sticky" top={0} zIndex={10}>
  <Flex align="center" justify="space-between" wrap="wrap" gap={2}>

    {/* Kiri: Hamburger + Logo */}
    <Flex align="center" flexShrink={0}>
      <IconButton
        display={{ base: "flex", md: "none" }}
        onClick={onOpen}
        icon={<Icon as={FaBars} />}
        variant="outline"
        colorScheme="whiteAlpha"
        size="sm"
        mr={2}
        aria-label="Menu"
      />
      <Image src={Logo} alt="Logo" boxSize={{ base: "28px", md: "40px" }} mr={2} />
      <Box>
        <Text fontSize={{ base: "sm", md: "lg" }} fontWeight="bold" lineHeight="1">Google Fit - Bugarin </Text>
        <Text fontSize={{ base: "xs", md: "sm" }} lineHeight="1">Tracker</Text>
      </Box>
    </Flex>

    {/* Kanan: Datepicker + Avatar+Email + Tombol */}
    <Flex align="center" gap={{ base: 1, md: 2 }} flexWrap="wrap" justify="flex-end" flex="1" minW={0}>
                {fitnessData && (
                  <DatePicker
                    selected={parseDateString(selectedDate)}
                    onChange={handleGantiTanggalKalender}
                    filterDate={filterTanggal}
                    minDate={minDate}
                    maxDate={today}
                    dateFormat="E, d MMM"
                    locale="id"
                    customInput={
                      <Input
         size="xs"
              bg="whiteAlpha.200"
              borderColor="whiteAlpha.300"
              color="white"
              w={{ base: "90px", sm: "110px", md: "160px" }}
              fontSize={{ base: "xs", md: "sm" }}
              _hover={{ bg: "whiteAlpha.300" }}
              cursor="pointer"
              readOnly
                      />
                    }
                    popperPlacement="bottom-end"
                  />
                )}
    <Flex align="center" gap={1} display={{ base: "none", md: "flex" }}>
         <Avatar size="xs" name={userEmail || "Guest"} />
         <Text fontSize="sm" fontWeight="bold" noOfLines={1} maxW="140px">
           {userEmail}
         </Text>
       </Flex>
                       <Button colorScheme="whiteAlpha" variant="outline" size="sm" onClick={handleLogout}>
                  Logout
                </Button>
     {/* Toggle Dark/Light */}
       <IconButton
         size="xs"
         icon={colorMode === "light"? "🌙" : "☀️"}
         variant="outline"
         colorScheme="whiteAlpha"
         onClick={toggleColorMode}
         aria-label="Toggle theme"
       />              </Flex>
            </Flex>
          </Box>

    <Flex direction={{ base: "column", md: "row" }}>
             {/* SIDEBAR DESKTOP */}
             <Box
               w={{ md: "220px" }}
               h="100vh"
               p={4}
               bg={colorMode === "light"? "gray.100" : "gray.700"}
               display={{ base: "none", md: "block" }}
               position="sticky"
               top="56px"
               className="no-print"
             >
                <Stack spacing={7}>
                <Text cursor="pointer" color={colorMode === "light"? "teal.500" : "white"} fontWeight="bold">Home</Text>
                <Text cursor="pointer" color={colorMode === "light"? "teal.500" : "white"} fontWeight="bold">About Us</Text>
                <Text cursor="pointer" color={colorMode === "light"? "teal.500" : "white"} fontWeight="bold">Contacts</Text>
                <Button colorScheme="blue" variant="solid" size="sm" onClick={() => { loginWithGoogle(); onClose(); }}>
                  Connect Google Fit
                </Button>

                <Button
                  colorScheme="green"
                  variant="solid"
                  size="sm"
                  onClick={handleOpenPasswordModal}
                  isLoading={kirimLoading}
                  isDisabled={!fitnessData || kirimLoading}
                  leftIcon={<Icon as={FaShoePrints} />}
                >
                  Kirim Data 7 Hari
                </Button>
                {kirimStatus && <Text fontSize="xs" mt={1}>{kirimStatus}</Text>}

                <Button
                  colorScheme="red"
                  variant="solid"
                  size="sm"
                  onClick={() => {
                    if (!fitnessData) {
                      alert('Connect Google Fit dulu baru bisa download PDF');
                      return;
                    }
                    const printStyle = `
                      <style>
                        @page { size: A4; margin: 10mm; }
                        @media print {
                          * {
                            -webkit-print-color-adjust: exact!important;
                            color-adjust: exact!important;
                            print-color-adjust: exact!important;
                          }
                          body { background: white!important; }
                         .no-print { display: none!important; }
                         .chart-container { page-break-inside: avoid!important; }
                         .recharts-wrapper { page-break-inside: avoid!important; }
                        }
                      </style>
                    `;
                    const originalContents = document.body.innerHTML;
                    const printContents = printStyle + componentRef.current.innerHTML;
                    document.body.innerHTML = printContents;
                    window.print();
                    document.body.innerHTML = originalContents;
                    window.location.reload();
                  }}
                  leftIcon={<Icon as={FaDownload} />}
                >
                  Download PDF
                </Button>
              </Stack>
            </Box>


            <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
              <DrawerOverlay />
              <DrawerContent bg={colorMode === "light"? "gray.100" : "gray.700"}>
                <DrawerCloseButton />
                <DrawerHeader>Menu</DrawerHeader>
                <DrawerBody>
                  <Stack spacing={7}>
                    <Text cursor="pointer" color={colorMode === "light"? "teal.500" : "white"} fontWeight="bold" onClick={onClose}>Home</Text>
                    <Text cursor="pointer" color={colorMode === "light"? "teal.500" : "white"} fontWeight="bold" onClick={onClose}>About Us</Text>
                    <Text cursor="pointer" color={colorMode === "light"? "teal.500" : "white"} fontWeight="bold" onClick={onClose}>Contacts</Text>
      <Button colorScheme="blue" variant="solid" size="sm" onClick={() => { loginWithGoogle(); onClose(); }}>
  Connect Google Fit
</Button>
                    <Button variant="outline" onClick={toggleColorMode}>
                      Toggle {colorMode === "light"? "Dark" : "Light"} Mode
                    </Button>
                  </Stack>
                </DrawerBody>
              </DrawerContent>
            </Drawer>

            <Flex direction="column" w={{ base: "100%", md: "80%" }} p={4} ref={componentRef}>
              {fitnessData? (
                <Stack spacing={6}>
                  <Flex justify="space-between" align="center" wrap="wrap" gap={4}>
                    <Text fontSize="2xl" fontWeight="bold">Ringkasan Aktivitas</Text>
                    <Flex gap={3}>
                      <ButtonGroup size="sm" isAttached variant="outline">
                        <IconButton icon={<BiBarChart />} onClick={() => setChartType('bar')} colorScheme={chartType === 'bar'? 'blue' : 'gray'} aria-label="Bar" />
                        <IconButton icon={<BiLineChart />} onClick={() => setChartType('line')} colorScheme={chartType === 'line'? 'blue' : 'gray'} aria-label="Line" />
                      </ButtonGroup>
                      <Select value={jumlahHari} onChange={handleGantiHari} w="180px" bg="white" isDisabled={isLoading}>
                        <option value={7}>7 hari terakhir</option>
                        <option value={14}>14 hari terakhir</option>
                        <option value={30}>30 hari terakhir</option>
                        <option value={90}>90 hari terakhir</option>
                        <option value={150}>150 hari terakhir</option>
                      </Select>
                    </Flex>
                  </Flex>

                  <Grid templateColumns={{ base: "1fr", sm: "1fr 1fr", lg: "repeat(5, 1fr)" }} gap={4}>
                    <GridItem bgGradient="linear(to-br, blue.400, blue.600)" p={4} rounded="xl" shadow="lg" color="white" className="chart-container">
                      <Flex justify="space-between" align="start">
                        <Stat>
                          <StatLabel fontSize="sm" opacity={0.9}>
                            Langkah
                            <Text as="span" display="block" fontSize="xs" opacity={0.8} mt={0.5}>
                              {selectedDate}
                            </Text>
                          </StatLabel>
                          <StatNumber fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold">{displaySteps}</StatNumber>
                        </Stat>
                        <Icon as={FaWalking} boxSize={{ base: 6, md: 8 }} opacity={0.8} />
                      </Flex>
                    </GridItem>

                    <GridItem bgGradient="linear(to-br, teal.400, teal.600)" p={4} rounded="xl" shadow="lg" color="white" className="chart-container">
                      <Flex justify="space-between" align="start">
                        <Stat>
                          <StatLabel fontSize="sm" opacity={0.9}>
                            Poin Kardio
                            <Text as="span" display="block" fontSize="xs" opacity={0.8} mt={0.5}>
                              {selectedDate}
                            </Text>
                          </StatLabel>
                          <StatNumber fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold">{displayCardio}</StatNumber>
                        </Stat>
                        <Icon as={FaHeart} boxSize={{ base: 6, md: 8 }} opacity={0.8} />
                      </Flex>
                    </GridItem>

                    <GridItem bgGradient="linear(to-br, purple.400, purple.600)" p={4} rounded="xl" shadow="lg" color="white" className="chart-container">
                      <Flex justify="space-between" align="start">
                        <Stat>
                          <StatLabel fontSize="sm" opacity={0.9}>Berat Badan</StatLabel>
                          <StatNumber fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold">{displayWeight} <Text as="span" fontSize="lg">kg</Text></StatNumber>
                        </Stat>
                        <Icon as={FaWeight} boxSize={{ base: 6, md: 8 }} opacity={0.8} />
                      </Flex>
                    </GridItem>

                    <GridItem bgGradient="linear(to-br, orange.400, orange.600)" p={4} rounded="xl" shadow="lg" color="white" className="chart-container">
                      <Flex justify="space-between" align="start">
                        <Stat>
                          <StatLabel fontSize="sm" opacity={0.9}>Tinggi Badan</StatLabel>
                          <StatNumber fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold">{displayHeight} <Text as="span" fontSize="lg">cm</Text></StatNumber>
                        </Stat>
                        <Icon as={FaRulerVertical} boxSize={{ base: 6, md: 8 }} opacity={0.8} />
                      </Flex>
                    </GridItem>

                    <GridItem bgGradient="linear(to-br, pink.400, pink.600)" p={4} rounded="xl" shadow="lg" color="white" className="chart-container">
                      <Flex justify="space-between" align="start">
                        <Stat>
                          <StatLabel fontSize="sm" opacity={0.9}>Detak Jantung</StatLabel>
                          <StatNumber fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold">{displayHeartRate} <Text as="span" fontSize="lg">bpm</Text></StatNumber>
                        </Stat>
                        <Icon as={FaHeartbeat} boxSize={{ base: 6, md: 8 }} opacity={0.8} />
                      </Flex>
                    </GridItem>
                  </Grid>

                  <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={6}>
                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" colSpan={{ base: 1, lg: 2 }} className="chart-container">
                      <Text fontWeight="bold" mb={3} textAlign="center" fontSize={{ base: "md", md: "lg" }}>
                        Body Mass Index - {selectedDate}
                      </Text>
                      <Box w="100%" maxW={{ base: "300px", sm: "350px", md: "400px" }} mx="auto">
                        <GaugeChart
                          id="bmi-gauge"
                          nrOfLevels={5}
                          colors={["#3182CE", "#38A169", "#ECC94B", "#ED8936", "#E53E3E"]}
                          arcWidth={0.3}
                          percent={displayBmi? Math.min(displayBmi / 45, 1) : 0}
                          textColor={displayBmiColor}
                          needleColor="#2D3748"
                          needleBaseColor="#2D3748"
                          formatTextValue={() => displayBmi? displayBmi.toFixed(1) : '-'}
                          style={{ width: '100%', height: 'auto' }}
                          textComponentFontSize={24}
                          animate={true}
                          animDelay={0}
                        />
                        <Flex justify="space-between" fontSize={{ base: "2xs", sm: "xs" }} color="gray.500" mt={-2} px={{ base: 2, md: 4 }}>
                          <Text>15</Text>
                          <Text>18.5</Text>
                          <Text>25</Text>
                          <Text>30</Text>
                          <Text>40</Text>
                          <Text>45</Text>
                        </Flex>
                      </Box>
                      <Flex justify="center" mt={3}>
                        <Badge
                          fontSize={{ base: "sm", md: "md" }}
                          px={{ base: 3, md: 4 }}
                          py={1}
                          bg={displayBmiColor}
                          color="white"
                        >
                          {displayBmiCategory || 'Tidak ada data'}
                        </Badge>
                      </Flex>
                      <Text fontSize={{ base: "xs", sm: "sm" }} textAlign="center" color="gray.600" mt={2}>
                        {displayWeight}kg / {displayHeight}cm - {selectedDate}
                        {!selectedData?.weight && lastWeightHeight.tanggal && (
                          <Text as="span" fontSize="xs" color="orange.500"> *data {lastWeightHeight.tanggal}</Text>
                        )}
                      </Text>
                      {displayBmi >= 30 && (
                        <Alert status="warning" mt={4} borderRadius="md" fontSize={{ base: "xs", sm: "sm" }}>
                          <AlertIcon />
                          <Box>
                            <AlertTitle fontSize={{ base: "sm", md: "md" }}>Perhatian!</AlertTitle>
                            <AlertDescription fontSize={{ base: "xs", sm: "sm" }}>
                              BMI kamu {displayBmi.toFixed(1)} pada {selectedDate} masuk kategori {displayBmiCategory}. Risiko kesehatan meningkat.
                            </AlertDescription>
                          </Box>
                        </Alert>
                      )}
                      {displayBmi >= 25 && displayBmi < 30 && (
                        <Alert status="info" mt={4} borderRadius="md" fontSize={{ base: "xs", sm: "sm" }}>
                          <AlertIcon />
                        


                          <Box>
                            <AlertTitle fontSize={{ base: "sm", md: "md" }}>Info</AlertTitle>
                            <AlertDescription fontSize={{ base: "xs", sm: "sm" }}>
                              BMI kamu {displayBmi.toFixed(1)} pada {selectedDate} masuk kategori Overweight.
                            </AlertDescription>
                          </Box>
                        </Alert>
                      )}
                    </GridItem>

                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" colSpan={{ base: 1, lg: 2 }} className="chart-container">
                      <Text fontWeight="bold" mb={2}>Skor Kesehatan - {selectedDate}</Text>
                      <Flex align="center" gap={3}>
                        <Text fontSize="3xl" fontWeight="bold" color={`${displayHealthScore.color}.500`}>
                          {displayHealthScore.persen}
                        </Text>
                        <Badge colorScheme={displayHealthScore.color} fontSize="md">
                          {displayHealthScore.label}
                        </Badge>
                      </Flex>
                      <Progress value={displayHealthScore.persen} colorScheme={displayHealthScore.color} mt={2} borderRadius="md" />
                    </GridItem>
                  </Grid>

                  <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" colSpan={{ base: 1, lg: 2 }} className="chart-container">
                    <Text fontWeight="bold" mb={3} textAlign="center">Perbandingan vs Standar WHO - {selectedDate}</Text>
                    <ResponsiveContainer width="100%" height={{ base: 350, md: 400 }}>
                      <BarChart
                        data={healthDetail}
                        layout="vertical"
                        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" horizontal={false} opacity={0.2} />
                        <XAxis type="number" domain={[0, 100]} tickFormatter={(v) => `${v}%`} />
                        <YAxis dataKey="indikator" type="category" width={60} fontSize={12} />
                        <Tooltip
                          formatter={(v, name, props) => [
                            `${v}% (${props.payload.nilai}${props.payload.satuan})`,
                            name
                          ]}
                        />
                        <Legend />
                        <Bar dataKey="target" fill="#38A169" name="Target WHO" radius={[0, 4, 4, 0]} barSize={12} />
                        <Bar dataKey="aktual" fill="#3182CE" name="Skor Kamu" radius={[0, 4, 4, 0]} barSize={12} />
                      </BarChart>
                    </ResponsiveContainer>

                    <SimpleGrid columns={{ base: 1, md: 3 }} spacing={2} mt={4}>
                      {healthDetail.map(item => (
                        <Flex key={item.indikator} justify="space-between" p={2} bg={item.aktual >= 100? 'green.50' : item.aktual >= 60? 'orange.50' : 'red.50'} rounded="md">
                          <Text fontSize="sm" fontWeight="bold">{item.indikator}</Text>
                          <Badge colorScheme={item.aktual >= 100? 'green' : item.aktual >= 60? 'orange' : 'red'}>
                            {item.aktual}% / {item.nilai}{item.satuan}
                          </Badge>
                        </Flex>
                      ))}
                    </SimpleGrid>
                  </GridItem>




{/* GRAFIK HISTORY DARI MYSQL */}
<Text fontSize="xl" fontWeight="bold" mt={4}>History dari Database</Text>
<Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={6}>
  {/* 1. GRAFIK BMI HISTORY */}
  <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container">
    <Text fontWeight="bold" mb={3}>History BMI - {jumlahHari} Hari Terakhir</Text>
    <ResponsiveContainer width="100%" height={300}>

  <LineChart data={historyData}>
    <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
    <XAxis dataKey="tanggal" fontSize={10} interval={'preserveStartEnd'} />
    <YAxis 
      domain={[15, 40]} 
      ticks={[15, 18.5, 25, 30, 40]}
      tickFormatter={(v) => v.toFixed(1)} 
    />
    <Tooltip 
      formatter={(v, name, props) => [
        `${parseFloat(v).toFixed(1)} - ${props.payload.bmi_category}`, 
        'BMI'
      ]}
      labelFormatter={(label) => `Tanggal: ${label}`}
    />
    <Legend />
    <Line 
      type="monotone" 
      dataKey="bmi" 
      stroke="#E53E3E" 
      strokeWidth={3} 
      dot={{ r: 3, fill: '#E53E3E' }} 
      name="BMI" 
      connectNulls={true}
    />
    <ReferenceLine y={18.5} stroke="#3182CE" strokeDasharray="5 5" label={{ value: "Underweight", position: "insideTopLeft", fontSize: 10 }} />
    <ReferenceLine y={25} stroke="#38A169" strokeDasharray="5 5" label={{ value: "Normal", position: "insideTopLeft", fontSize: 10 }} />
    <ReferenceLine y={30} stroke="#ED8936" strokeDasharray="5 5" label={{ value: "Overweight", position: "insideTopLeft", fontSize: 10 }} />
  </LineChart>
      
    </ResponsiveContainer>
  </GridItem>

  {/* 2. GRAFIK HEALTH SCORE HISTORY */}
  <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container">
    <Text fontWeight="bold" mb={3}>History Skor Kesehatan - {jumlahHari} Hari Terakhir</Text>
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={historyData}>
        <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
        <XAxis dataKey="tanggal" fontSize={11} />
        <YAxis domain={[0, 100]} />
        <Tooltip formatter={(v, name, props) => [`${v} - ${props.payload.health_label}`, 'Skor']} />
        <Bar dataKey="health_score" name="Skor" radius={[4, 4, 0, 0]}>
          {historyData.map((entry, index) => {
            let color = '#E53E3E';
            if (entry.health_score >= 80) color = '#38A169';
            else if (entry.health_score >= 60) color = '#319795';
            else if (entry.health_score >= 40) color = '#DD6B20';
            return <Cell key={`cell-${index}`} fill={color} />;
          })}
        </Bar>
        <ReferenceLine y={80} stroke="#38A169" strokeDasharray="5 5" />
        <ReferenceLine y={60} stroke="#319795" strokeDasharray="5 5" />
        <ReferenceLine y={40} stroke="#DD6B20" strokeDasharray="5 5" />
      </BarChart>
    </ResponsiveContainer>
  </GridItem>
</Grid>

<SimpleGrid columns={{ base: 1, lg: 2, xl: 3 }} spacing={6}></SimpleGrid>




                  <SimpleGrid columns={{ base: 1, lg: 2, xl: 3 }} spacing={6}>
                    <ChartCard title="Energi Dikeluarkan" dataKey="energi" name="Kalori" unit="kkal" icon={FaFire} />
                    <ChartCard title="Jarak" dataKey="jarakKm" name="Jarak" unit="km" icon={FaRoute} />
                    <ChartCard title="Menit Bergerak" dataKey="menitBergerak" name="Menit" unit="menit" icon={FaRunning} />
                    <ChartCard title="Menit Aktif" dataKey="menitAktif" name="Poin" unit="poin" icon={FaHeart} />
                  </SimpleGrid>

                  <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={6}>
                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container">
                      <Text fontWeight="bold" mb={3}>Aktivitas: Langkah & Menit Aktif</Text>
                      <ResponsiveContainer width="100%" height={250}>
                        <BarChart data={dataChart}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="tanggal" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Bar dataKey="step_count" fill="#3182CE" name="Langkah" />
                          <Bar dataKey="menitBergerak" fill="#38A169" name="Menit Aktif" />
                        </BarChart>
                      </ResponsiveContainer>
                    </GridItem>

                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container">
                      <Text fontWeight="bold" mb={3}>Poin Kardio {jumlahHari} Hari Terakhir</Text>
                      <ResponsiveContainer width="100%" height={250}>
                        <BarChart data={dataChart}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="tanggal" />
                          <YAxis />
                          <Tooltip />
                          <Bar dataKey="menitAktif" fill="#38B2AC" name="Poin Kardio" />
                        </BarChart>
                      </ResponsiveContainer>
                    </GridItem>

                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container">
                      <Text fontWeight="bold" mb={3}>Kalori Masuk vs Keluar</Text>
                      <ResponsiveContainer width="100%" height={250}>
                        <LineChart data={dataChart}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="tanggal" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Line type="monotone" dataKey="calories_in" stroke="#ED8936" name="Kalori Masuk" />
                          <Line type="monotone" dataKey="energi" stroke="#E53E3E" name="Kalori Keluar" />
                        </LineChart>
                      </ResponsiveContainer>
                    </GridItem>


                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container">
                      <Text fontWeight="bold" mb={3}>Durasi Tidur</Text>
                      <ResponsiveContainer width="100%" height={250}>
                        <BarChart data={dataChart}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="tanggal" />
                          <YAxis tickFormatter={(v) => `${Math.round(v/60)}j`} />
                          <Tooltip formatter={(v) => `${Math.floor(v/60)}j ${v%60}m`} />
                          <Bar dataKey="sleepMinutes" fill="#805AD5" name="Durasi Tidur" />
                        </BarChart>
                      </ResponsiveContainer>
                    </GridItem>

                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container">
                      <Text fontWeight="bold" mb={3}>Berat Badan</Text>
                      <ResponsiveContainer width="100%" height={250}>
                        <LineChart data={dataChart}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="tanggal" />
                          <YAxis domain={['dataMin - 5', 'dataMax + 5']} tickFormatter={(v) => `${v} kg`} />
                          <Tooltip formatter={(v) => `${v} kg`} />
                          <Line type="monotone" dataKey="weight" stroke="#9F7AEA" name="Berat (kg)" strokeWidth={2} dot={{ r: 4 }} connectNulls={true} isAnimationActive={false} />
                        </LineChart>
                      </ResponsiveContainer>
                    </GridItem>

                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container">
                      <Text fontWeight="bold" mb={3}>Detak Jantung & Air Minum</Text>
                      <ResponsiveContainer width="100%" height={250}>
                        <LineChart data={dataChart}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="tanggal" />
                          <YAxis yAxisId="left" />
                          <YAxis yAxisId="right" orientation="right" />
                          <Tooltip />
                          <Legend />
                          <Line yAxisId="left" type="monotone" dataKey="heart_rate" stroke="#D53F8C" name="Detak Jantung" />
                          <Line yAxisId="right" type="monotone" dataKey="water" stroke="#00B5D8" name="Air (Liter)" />
                        </LineChart>
                      </ResponsiveContainer>
                    </GridItem>
                  </Grid>

                  <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={6}>
                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md">
                      <Text fontWeight="bold" mb={3}>Denyut Istirahat & Saturasi Oksigen</Text>








               
                      <ResponsiveContainer width="100%" height={250}>
                        <LineChart data={dataChart}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="tanggal" />
                          <YAxis yAxisId="left" domain={[40, 100]} tickFormatter={(v) => `${v} bpm`} />
                          <YAxis yAxisId="right" orientation="right" domain={[90, 100]} tickFormatter={(v) => `${v}%`} />
                          <Tooltip />
                          <Legend />
                          <Line yAxisId="left" type="monotone" dataKey="resting_heart_rate" stroke="#E53E3E" name="Istirahat (bpm)" dot={false} />
                          <Line yAxisId="right" type="monotone" dataKey="oxygen_saturation" stroke="#3182CE" name="Oksigen (%)" dot={false} />
                        </LineChart>
                      </ResponsiveContainer>
                    </GridItem>

                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container">
                      <Text fontWeight="bold" mb={3}>Gula Darah</Text>
                      <ResponsiveContainer width="100%" height={250}>
                        <LineChart data={dataChart}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="tanggal" />
                          <YAxis domain={['dataMin - 10', 'dataMax + 10']} tickFormatter={(v) => `${v} mg/dL`} />
                          <Tooltip formatter={(v) => `${v} mg/dL`} />
                          <Line type="monotone" dataKey="blood_glucose" stroke="#DD6B20" name="Gula Darah" strokeWidth={2} dot={{ r: 3 }} connectNulls={true} />
                        </LineChart>
                      </ResponsiveContainer>
                    </GridItem>
                  </Grid>

                </Stack>
              ) : (
                <Flex h="calc(100vh - 64px)" bg={colorMode === "light" ? "white" : "gray.800"} alignItems="center" justifyContent="center" p={4}>
                  <Box
                    bgImage="url(/bg-health4.jpg)"
                    bgSize="cover"
                    bgPosition="center"
                    bgRepeat="no-repeat"
                    p={{ base: 6, md: 10 }}
                    rounded="2xl"
                    shadow="2xl"
                    textAlign="center"
                    maxW="600px"
                    w="100%"
                    position="relative"
                    overflow="hidden"
                  >
                    <Box position="absolute" top={0} left={0} right={0} bottom={0} bg="rgba(255,255,255,0.6)" />
                    <Box position="relative" zIndex={1}>
                      <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="bold" color="gray.800" mb={3}>
                        Selamat Datang di Klinik Bugarin Tracker
                      </Text>
                      <Text fontSize="md" color="gray.700" mb={6}>
                        Klik "Connect Google Fit" untuk mulai pantau aktivitas dan kesehatanmu
                      </Text>
      <Button colorScheme="blue" variant="solid" size="sm" onClick={loginWithGoogle}>
  Connect Google Fit
</Button>
                    </Box>
                  </Box>
                </Flex>
              )}
            </Flex>
          </Flex>
             {/* MODAL PASSWORD */}
                    <Modal isOpen={isPasswordOpen} onClose={onPasswordClose} isCentered>
                      <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(10px)" />
                      <ModalContent>
                        <ModalHeader>
                          <Flex align="center" gap={2}>
                            <Icon as={FaLock} color="green.500" />
                            <Text>Password Diperlukan</Text>
                          </Flex>
                        </ModalHeader>
                        <ModalCloseButton />
                        <ModalBody pb={6}>
                          <FormControl isInvalid={!!passwordError}>
                            <FormLabel>Masukkan password untuk kirim data 7 hari terakhir</FormLabel>
                            <InputGroup>
                              <Input
                                type={showPassword? 'text' : 'password'}
                                placeholder="Password..."
                                value={inputPassword}
                                onChange={(e) => {
                                  setInputPassword(e.target.value);
                                  setPasswordError('');
                                }}
                                onKeyPress={(e) => e.key === 'Enter' && handleSubmitPassword()}
                                autoFocus
                              />
                              <InputRightElement width="4.5rem">
                                <Button h="1.75rem" size="sm" onClick={() => setShowPassword(!showPassword)}>
                                  {showPassword? 'Hide' : 'Show'}
                                </Button>
                              </InputRightElement>
                            </InputGroup>
                            {passwordError && <Text color="red.500" fontSize="sm" mt={1}>{passwordError}</Text>}
                          </FormControl>
                        </ModalBody>
                        <ModalFooter>
                          <Button colorScheme="gray" mr={3} onClick={onPasswordClose}>
                            Batal
                          </Button>
                          <Button colorScheme="green" onClick={handleSubmitPassword}>
                            Kirim Sekarang
                          </Button>
                        </ModalFooter>
                      </ModalContent>
                    </Modal>
        </Box>
      )}
    </>
  );
};


export default DashboardContent;